<template>
  <div class="app flex-row align-items-center">
    <vue-progress-bar></vue-progress-bar>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h2>{{ $t('reset_password.create_new_password') }}</h2>
                <div class="clearfix"></div>
                <!--<span v-show="error != null" class="text-danger">{{ error }}</span>-->
                <div class="clearfix"><br/></div>
                <b-form class="container" v-on:keydown.enter="submit">
                  <b-form-group v-bind:label="$t('reset_password.password')" :label-cols="3" :horizontal="true">
                    <b-form-input id="password" type="password" class="form-control"
                                  name="password" v-model="password"
                                  :state="!$v.password.$invalid"
                                  aria-describedby="password-feedback"
                           />
                    <div class="xs-flex xs-items-center xs-mb-5">
                      <span class="text-alert">{{$t('register.password_condition')}}</span>
                    </div>
                    <div class="xs-flex xs-items-center xs-mb-5" v-for="(passwordValid, index) in passwordValidation" :key="index">
                      <i class="fa" v-bind:class="{ 'fa-times xs-text-red': (passwordValid.status === 0), 'fa-check xs-text-green-dark': (passwordValid.status === 1), 'fa-times xs-text-gray': (passwordValid.status === 2)}" />
                      <div class="typo-l7"
                           v-bind:class="{ 'xs-text-red': (passwordValid.status === 0), 'xs-text-green-dark': (passwordValid.status === 1), 'xs-text-gray': (passwordValid.status === 2)}">
                        <span>{{passwordValid.message}}</span>
                      </div>
                    </div>
                    <div class="xs-flex xs-items-center xs-mb-5">
                      <span class="text-alert">{{$t('register.password_condition_infomation')}}</span>
                    </div>
                  </b-form-group>

                  <b-form-group v-bind:label="$t('reset_password.confirm_password')" :label-cols="3" :horizontal="true">
                    <b-form-input id="confirmPassword" type="password" class="form-control"
                           name="confirmPassword" v-model="confirmPassword"
                                  :state="!$v.confirmPassword.$invalid"
                                  aria-describedby="confirm-feedback"
                           />
                    <b-form-invalid-feedback v-if="!$v.confirmPassword.$invalid" id="confirm-feedback">
                      {{$t('message.password_identical')}}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-row>
                    <b-col cols="8">
                      <b-button @click="submit" variant="dark" class="px-4" id="btn-login" :disabled="$v.password.$invalid || $v.confirmPassword.$invalid">
                        {{ buttonText }}
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
  .login-language {
    width: 100px;
    float: right;
    margin-top: -10px;
  }

  .login-card-body {
    padding-top: 0px !important;
    margin-top: -20px !important;
  }

  .login-logo {
    width: 85%;
    margin-bottom: 20px;
  }

  .login-copyright {
    margin-top: 40px;
    margin-bottom: -30px;
  }
  .xs-flex i {
    float: left;
    margin-right: 5px;
  }
  .xs-text-green-dark {
    color: #00a67c;
  }
  .xs-text-red {
    color: red;
  }
  .xs-text-gray {
    color: #999580;
  }

</style>

<script>
  import ChangeLanguage from '../../components/Partials/ChangeLanguages.vue'
  import {validationMixin} from 'vuelidate'
  import {required, sameAs} from 'vuelidate/lib/validators'
  const PASSWORD_MIN = 8

  export default {
    name: 'ResetPassword',
    components: {
      ChangeLanguage
    },
    data() {
      return {
        buttonText: ''
      }
    },
    created() {
      this.buttonText = this.$t('reset_password.reset_password')
      const isNewRegister = this.$route.query.is_new_register
      if (isNewRegister === 'true') {
        this.buttonText = this.$t('reset_password.set_new_password')
      }      
    },
    mounted() {
      this.passwordValidation = [
        {
          status: 0,
          message: this.$t('validate_password_no_uppercase'),
          regex: /[A-Z]/
        },
        {
          status: 0,
          message: this.$t('validate_password_no_lowercase'),
          regex: /[a-z]/
        },
        {
          status: 0,
          message: this.$t('validate_password_no_number'),
          regex: /[0-9]/
        },
        {
          status: 0,
          message: this.$t('validate_password_no_non_alphanumberic'),
          regex: /[^a-zA-Z\d\s:]/
        }
      ]
      // check token reset
      let vm = this
      vm.axios.user.forgotPasswordToken(this.$route.params.token, respone => {
      }, error => {
        this.$router.push({'name': 'Page404'})
      })
    },
    data () {
      return {
        password: '',
        confirmPassword: '',
        passwordValidation: []
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      password: {
        required,
        strongPassword (password) {
          let validationResult = []
          let count = 0
          this.passwordValidation = this.passwordValidation.map((rule) => {
            if (rule.regex.test(password)) {
              rule.status = 1
              validationResult.push(rule.status)
              count++
            } else {
              rule.status = 0
              validationResult.push(rule.status)
            }
            return rule
          })
          this.passwordValidation.forEach((item) => {
            if (!item.status && count === 3) {
              item.status = 2
            }
          })
          return (count > 2 && password.length >= PASSWORD_MIN)
        }
      },
      confirmPassword: {
        sameAsPassword: sameAs('password')
      }
      // form: {
      //   password: {
      //     required,
      //     minLength: minLength(6)
      //   },
      //   confirmPassword: {
      //     sameAsPassword: sameAs('passwords')
      //   }
      // }
    },
    methods: {
      submit: function () {
        let vm = this
        vm.axios.user.resetPassword({'password': vm.password, 'token': this.$route.params.token}, respone => {
          if (respone.data.status) {
            this.$router.push({'name': 'AdminLogin'})
          }
        }, error => {
          console.log('error', error)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/ResetPassword.vue